import React from "react";
import GuestPosts from "./GuestPost";
import OrderSummary from "./OrderSummary";
import Transaction from "./Transactions";

function ConfirmOrderDetail({
  orderData,
  guestPosts,
  guestTotal,
  linkInserts,
  nicheEdits,
  linkTotal,
  nicheTotal,
  transactions,
}) {
  return (
    <div className="row d-xl-flex" style={{ paddingInline: "1rem" }}>
      <div className="col-12 col-lg-7 col-xl flex-grow-1">
        {!!guestPosts?.length && (
          <GuestPosts guestPosts={guestPosts} guestTotal={guestTotal} />
        )}
        {/* {!!linkInserts?.length && (
          <LinkTable
            linkInserts={linkInserts}
            linkTotal={linkTotal}
            handleDeleteCartItem={handleDeleteCartItem}
          />
        )}
        {!!nicheEdits?.length && (
          <NicheTable
            nicheEdits={nicheEdits}
            nicheTotal={nicheTotal}
            handleDeleteCartItem={handleDeleteCartItem}
          />
        )} */}
        {!!transactions?.length && <Transaction transactions={transactions} />}
      </div>
      <OrderSummary
        orderData={orderData}
        guestTotal={guestTotal}
        linkTotal={linkTotal}
        nicheTotal={nicheTotal}
        linkInserts={linkInserts}
        nicheEdits={nicheEdits}
        guestPosts={guestPosts}
      />
    </div>
  );
}

export default ConfirmOrderDetail;
